import * as types from "./actionTypes";
import * as authApi from "../api/authApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

// Action creators
export function authenticationSuccess(account) {
  return { type: types.AUTHENTICATION_SUCCESS, account };
}

export function authenticationFailed(account) {
  return { type: types.AUTHENTICATION_FAILED, account };
}

export function loginSuccess(account) {
  return { type: types.LOGIN_SUCCESS, account };
}

export function loginFailed(account) {
  return { type: types.LOGIN_FAILED, account };
}

export function adminSuccess(account) {
  return { type: types.ADMIN_SUCCESS, account };
}

export function adminFailed(account) {
  return { type: types.ADMIN_FAILED, account };
}

export function updateAccountVariable(account) {
  return { type: types.UPDATE_ACCOUNT_VARIABLE, account };
}

export function updateSecondaryAccount(account) {
  return { type: types.UPDATE_SECONDARY_ACCOUNT, account };
}

export function deleteSecondary() {
  return { type: types.DELETE_SECONDARY_ACCOUNT };
}

export function mfaRequired(account) {
  return { type: types.MFA_REQUIRED, account };
}

export function mfaSuccess(account) {
  return { type: types.MFA_SUCCESS, account };
}

export function mfaFailed(account) {
  return { type: types.MFA_FAILED, account };
}
export function logout() {
  return { type: types.LOGOUT };
}
// Register thunk
export function register(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .registerUser(userDetails)
      .then((account) => {
        //console.log(getState());
        if (account.status === "Pass") {
          dispatch(authenticationSuccess(account));
        } else {
          dispatch(authenticationFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function verifyMfa(mfaDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .verifyMfaCode(mfaDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(mfaSuccess(account));
          dispatch(loginSuccess(account));
        } else {
          dispatch(mfaFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function login(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .loginUser(userDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(loginSuccess(account));
        } else if (account.status === "MFA_REQUIRED") {
          dispatch(mfaRequired(account));
        } else {
          dispatch(loginFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

/*

export function login(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .loginUser(userDetails)
      .then((account) => {
        //console.log(getState());
        if (account.status === "Pass") {
          dispatch(loginSuccess(account));
        } else {
          dispatch(loginFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
*/

export function superlogin(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .loginAdmin(userDetails)
      .then((account) => {
        //console.log(getState());
        if (account.status === "Pass") {
          dispatch(loginSuccess(account));
        } else {
          dispatch(adminSuccess(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

// export const login = (data) => (dispatch) => {
//   return axios
//     .post("/api/login", data)
//     .then((response) => {
//       dispatch({
//         type: "LOGIN_SUCCESS",
//         payload: response.data,
//       });
//       return response.data;
//     })
//     .catch((error) => {
//       dispatch({
//         type: "LOGIN_FAIL",
//         payload: error.response?.data || { message: error.message },
//       });
//       throw error;
//     });
// };
